export const pageUrl = () => window.location.href;
export const pagePath = () => window.location.pathname;
export const pageReferer = () => document.referrer;
export const viewportWidth = () => window.innerWidth;
export const viewportHeight = () => window.innerHeight;
